"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = Title;
const React = __importStar(require("react"));
const react_jss_1 = require("react-jss");
const useStyles = (0, react_jss_1.createUseStyles)({
    title: {
        fontSize: "0.65rem",
        fontWeight: 700,
        color: ({ title }) => title ? `#${title.color.toString(16)}` : "inherit",
        textAlign: "inherit",
        textTransform: "uppercase",
    },
});
function Title(props) {
    const classes = useStyles(props);
    if (!props.title) {
        return null;
    }
    return React.createElement("span", { className: classes.title }, props.title.text);
}
